/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ind': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M640 864l-64-128h326.4c32 0 57.6-25.6 57.6-57.6V153.6c0-32-25.6-57.6-57.6-57.6H121.6c-32 0-57.6 25.6-57.6 57.6v524.8c0 32 25.6 57.6 57.6 57.6H448l-64 128H0v64h1024v-64H640zM185.6 672c-32 0-57.6-25.6-57.6-57.6V217.6c0-32 25.6-57.6 57.6-57.6h652.8c32 0 57.6 25.6 57.6 57.6v396.8c0 32-25.6 57.6-57.6 57.6H185.6z"/>'
  }
})
